import { AfterViewInit, Directive, HostListener, Inject, Input, OnDestroy, SkipSelf } from "@angular/core";
import { Subscription } from "rxjs";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { CommonToggleDisplayActionsDirective } from "./actions.directive";
import { TOGGLE_DISPLAY_STATE_PROP } from "./state-props";

@Directive({
    selector: "[toggleControlID]",
})
export class CommonToggleControlDirective implements AfterViewInit, OnDestroy {
    @Input("toggleControlID") public index: any;

    public selectedIndex: number;
    private state$: Subscription;

    constructor(
        public ngRedux: ImmutableRedux<any>,
        @SkipSelf() public actions: CommonToggleDisplayActionsDirective,
        @Inject(TOGGLE_DISPLAY_STATE_PROP) public rootProp,
    ) { }

    public ngAfterViewInit() {
        this.state$ = this.ngRedux.select(this.rootProp, this.actions.stateProp).subscribe((state) => {
            this.selectedIndex = state.selectedIndex;
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }

    @HostListener("click")
    public onClick() {
        this.actions.toggle(this.index);
    }
}
